import React from 'react';
import { Flex } from '@ui-library/misc';
import Svg from '@svg/index';
import { Logo, CommonContainer } from './styles';

interface IProps {
  children: React.ReactNode;
  justifyCenter?: boolean;
  showLogo?: boolean;
  showLogoInForm?: boolean;
  removefullVw?: boolean;
}

export default ({
  children,
  justifyCenter = true,
  showLogo = false,
  showLogoInForm,
  removefullVw = false,
}: IProps) => (
  <CommonContainer>
    <Flex flexDirection="column" className={!removefullVw ? 'full-width-vw' : ''}>
      {showLogo && (
        <Logo>
          <Svg name="full-logo_02" height={20} />
        </Logo>
      )}
      {justifyCenter ? (
        <Flex flexDirection="column" alignItemsCenter justifyContentCenter className="full-cent">
          {showLogoInForm && (
            <Flex className="m-b-md" justifyContent="flex-start" alignItems="flex-start">
              <Svg name="full-logo_02" style={{ width: '350px' }} />
            </Flex>
          )}
          {children}
        </Flex>
      ) : (
        <Flex flexDirection="column" alignItemsCenter className="full-cent">
          {children}
        </Flex>
      )}
    </Flex>
  </CommonContainer>
);
